import { render, staticRenderFns } from "./ModalQc.vue?vue&type=template&id=2a2eaa72&"
import script from "./ModalQc.vue?vue&type=script&lang=js&"
export * from "./ModalQc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports